import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Grid from "@mui/material/Grid2";
import { MarkdownOrText } from "../../Common/MarkdownOrText";
import { SubconfigurationCompleteIndicatorIcon } from "./SubconfigurationCompleteIndicator";
export function SubconfigurationItemLabel(props) {
    const { item, showCompleteIndicator, textMode } = props;
    const labelNode = _jsx(MarkdownOrText, { text: item.label, textMode: textMode });
    if (!showCompleteIndicator) {
        return labelNode;
    }
    return (_jsxs(Grid, { container: true, spacing: 1, sx: {
            justifyContent: "center",
            alignItems: "center",
        }, children: [_jsx(Grid, { children: labelNode }), _jsx(Grid, { children: _jsx(SubconfigurationCompleteIndicatorIcon, { completed: item.isComplete }) })] }));
}
//# sourceMappingURL=SubconfigurationItemLabel.js.map